<div class="alert {{type}}">
  <mat-icon>{{icon}}</mat-icon>
  <span class="text">{{text}}</span>
  <ng-content></ng-content>
</div>